import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M13.748 2.034C13.152.742 11.442.5 8 .5S2.848.742 2.252 2.034a9 9 0 0 1 1.575-.377C4.982 1.479 6.379 1.43 8 1.43s3.018.049 4.174.227c.55.084 1.08.203 1.574.377"
                        fill="currentColor"
                    />
                    <path d="M3.334 7.7h9.333V6.3H3.334z" fill="currentColor" />
                    <path d="M3.667 10.534h4.667v-1.4H3.667z" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 2.83c-6.439 0-8.028.792-7.359 6.335S2.23 15.5 8 15.5s6.69-.792 7.359-6.335S14.439 2.83 8 2.83M2.527 5.014c-.457.364-.835 1.171-.496 3.983.166 1.373.337 2.352.565 3.074.223.702.47 1.06.725 1.28.26.223.668.425 1.433.56.78.138 1.816.19 3.246.19s2.466-.052 3.246-.19c.765-.135 1.173-.337 1.433-.56.256-.22.502-.578.725-1.28.228-.722.4-1.7.565-3.074.34-2.812-.04-3.62-.496-3.983-.284-.226-.786-.445-1.726-.59C10.815 4.28 9.598 4.23 8 4.23s-2.815.05-3.747.194c-.94.145-1.442.364-1.726.59"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
CardLinesStackedOutlinedSize16Glyph.displayName = 'CardLinesStackedOutlinedSize16Glyph';
